// Color utility for grouping rows by machine serial number
// 9 distinct pastel colors for better visibility

export const MACHINE_COLORS = [
  'rgba(59, 130, 246, 0.15)',   // Blue
  'rgba(16, 185, 129, 0.15)',   // Green
  'rgba(245, 158, 11, 0.15)',   // Amber
  'rgba(239, 68, 68, 0.15)',    // Red
  'rgba(139, 92, 246, 0.15)',   // Purple
  'rgba(236, 72, 153, 0.15)',   // Pink
  'rgba(6, 182, 212, 0.15)',    // Cyan
  'rgba(249, 115, 22, 0.15)',   // Orange
  'rgba(132, 204, 22, 0.15)',   // Lime
];

// Get color index for a serial number (consistent across renders)
export const getSerialColorIndex = (serial, serialList) => {
  if (!serial || !serialList) return -1;
  
  // Get unique serials in order of first appearance
  const uniqueSerials = [...new Set(serialList)];
  const index = uniqueSerials.indexOf(serial);
  
  return index >= 0 ? index % MACHINE_COLORS.length : -1;
};

// Get background color for a serial number
export const getSerialColor = (serial, serialList) => {
  const index = getSerialColorIndex(serial, serialList);
  return index >= 0 ? MACHINE_COLORS[index] : 'transparent';
};

// Generate a map of serial -> color for a dataset
export const generateSerialColorMap = (data, serialKey = 'machine_serial') => {
  const colorMap = {};
  const uniqueSerials = [...new Set(data.map(item => item[serialKey]).filter(Boolean))];
  
  uniqueSerials.forEach((serial, index) => {
    colorMap[serial] = MACHINE_COLORS[index % MACHINE_COLORS.length];
  });
  
  return colorMap;
};
